import React from 'react';
import { Loader as ChromaLoader } from '@iag-packages/chroma-react/lib/components';
import styled from 'styled-components';

const LoaderWrapper = styled.div`
  .c-loader__background {
    background: none;
  }
`;

export const Loader = () => (
  <LoaderWrapper>
    <ChromaLoader brand="coles" />
  </LoaderWrapper>
);

export default Loader;
